<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class='lt-scene_cupboard'>
    <Transition name="fade" v-show="holiday === 3" appear>
      <img
        src='../../assets/holiday-3.svg'
        class='lt-scene_cupboard_holiday'
        alt=""
      />
    </Transition>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    ...mapFields([
      'scene.status.holiday',
    ]),
  },
};
</script>
